// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.modal-body {
  min-height: 100px;
  padding: 10px;
  font-size: 14px;
}

.centered-content {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.app-version {
  display: flex;
  justify-content: center; /* таблица по центру модалки */
  padding: 8px;
}

table {
  border-collapse: collapse;
}

.label {
  text-align: left;
  padding: 4px 8px;
}

.value {
  text-align: left;
  padding: 4px 8px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
